$(function() {
	// Get the form.
	var form = $('#ajax-contact');

	// Get the messages div.
	var formMessages = $('#form-messages');
	var submitButton = $(form).find('button[type="submit"]');

	var refreshCsrfToken = function(xhr) {
		var csrfToken = xhr.getResponseHeader('X-CSRF-Token');

		if (csrfToken) {
			$(form).find('input[name="csrf_test_name"]').val(csrfToken);
		}
	};

	var resetTurnstile = function() {
		if (window.turnstile && typeof window.turnstile.reset === 'function') {
			window.turnstile.reset();
		}
	};

	// Set up an event listener for the contact form.
	$(form).submit(function(event) {
		// Stop the browser from submitting the form.
		event.preventDefault();

		// Submit the form using AJAX.
		$.ajax({
			type: 'POST',
			url: $(form).attr('action'),
			data: $(form).serialize(),
			beforeSend: function() {
				$(submitButton).prop('disabled', true);
			},
		})

		.done(function(response, textStatus, xhr) {
			refreshCsrfToken(xhr);

			// Make sure that the formMessages div has the 'success' class.
			$(formMessages).removeClass('alert-danger');
			$(formMessages).addClass('alert-success gbr-contact-message');

			// Set the message text.
			$(formMessages).html(response);

			$(form).hide();
			$(form).closest('.gbr-inquiry-form').addClass('gbr-inquiry-form-complete');
			// Clear the form.
			// $('#name').val('');
			// $('#email').val('');
			// $('#message').val('');
		})

		.fail(function(data) {
			refreshCsrfToken(data);
			resetTurnstile();
			$(submitButton).prop('disabled', false);

			// Make sure that the formMessages div has the 'error' class.
			$(formMessages).removeClass('alert-success');
			$(formMessages).addClass('alert-danger gbr-contact-message');

			// Set the message text.
			if (data.responseText !== '') {
				$(formMessages).html(data.responseText);
			} else {
				$(formMessages).html('Oops! An error occured please email info@greenbay.rentals');
			}
		});
	});
});
